import type { ProjectionPoint } from '@financego/core';

export function buildPolyline(
  points: readonly Pick<ProjectionPoint, 'balance'>[],
  width: number,
  height: number,
): string {
  if (points.length === 0) return `M 0 ${height / 2} L ${width} ${height / 2}`;
  const balances = points.map((point) => point.balance);
  const minimum = Math.min(...balances);
  const maximum = Math.max(...balances);
  const range = Math.max(1, maximum - minimum);
  const divisor = Math.max(1, points.length - 1);
  const coordinates = points.map((point, index) => {
    const x = (index / divisor) * width;
    const y = height - ((point.balance - minimum) / range) * (height - 12) - 6;
    return `${x.toFixed(2)} ${y.toFixed(2)}`;
  });
  return `M ${coordinates.join(' L ')}`;
}
